"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fioriToolsProxy = exports.serveStatic = void 0;
exports.serveStatic = 'fiori-tools-servestatic';
exports.fioriToolsProxy = 'fiori-tools-proxy';
//# sourceMappingURL=constants.js.map